<template>
  <b-modal
    ref="modal"
    :title="title"
    size="xl"
    hide-footer
  >
    <b-table
      :fields="fields"
      :items="items"
      class="mb-0"
      :tbody-tr-class="rowClass"
      sticky-header="calc(100vh - 160px)"
      label-sort-asc=""
      label-sort-desc=""
      label-sort-clear=""
      no-border-collapse
    >
      <template #cell(is_conform)="cell">
        <i
          class="fa-solid"
          :class="cell.value ? 'fa-circle-check' : 'fa-circle-xmark'"
        />
      </template>
    </b-table>
  </b-modal>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      items: [],
      fields: [
        {
          key: 'is_conform',
          label: this.$t('connector.label.status'),
          sortable: false,
          tdClass: 'align-middle modal-consistency-details-td-conform',
        },
        {
          key: 'label',
          label: this.$t('connector.label.label'),
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          key: 'id',
          label: this.$t('label.identifiant'),
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          key: 'ext_uri',
          label: this.$t('connector.label.uriterranga'),
          sortable: true,
          tdClass: 'align-middle',
        },
        {
          key: 'detail',
          label: this.$t('connector.label.difference_detail'),
          sortable: true,
          tdClass: 'align-middle modal-consistency-details-td-conform',
        },
      ],
    };
  },
  methods: {
    show({ items = [], title = "" } = {}) {
      this.items = items;
      this.title = title;
      this.$refs.modal.show();
    },
    rowClass(item) {
      return [
        item.is_enabled === false ? "modal-consistency-details-row-disabled" : null,
        item.is_conform ? "modal-consistency-details-row-conform" : null,
      ];
    },
  }
};
</script>

<style>
.modal-consistency-details-row-disabled {
  background-color: grey;
  color: lightgray;
  text-decoration-line: line-through;
}

.modal-consistency-details-td-conform {
  color: red;
  font-weight: bold;
}
.modal-consistency-details-row-conform .modal-consistency-details-td-conform {
  color: green;
}
.modal-consistency-details-row-conform.modal-consistency-details-row-disabled .modal-consistency-details-td-conform {
  color: lightgreen;
}
.modal-consistency-details-row-disabled .modal-consistency-details-td-conform {
  color: lightcoral;
}
</style>
